import axios from "axios";
import BASE_URL from "../../config";

const getAuthHeader = () => {
  const tokenData = JSON.parse(localStorage.getItem("authUser") || "{}");
  return {
    Authorization: `Bearer ${tokenData.accessToken}`,
    'Content-Type': 'application/json'
  };
};

export const getGroups = async (filter = {}) => {
  try {
    const response = await axios.post(`${BASE_URL}/api/Group/get`, filter, {
      headers: getAuthHeader(),
    });
    return response.data;
  } catch (error) {
    console.error("Error fetching groups:", error);
    throw error;
  }
};

export const saveGroup = async (group) => {
  const response = await axios.post(`${BASE_URL}/api/Group/save`, group, {
    headers: getAuthHeader(),
  });
  return response.data;
}; 